<template>
    <app-layout>
        <template v-slot:header>
            <Header :title="$t('promontial_application_form')" :is-filter="false">
            </Header>
        </template>
        <template v-slot:header-mobile>
            <HeaderMobile :title="$t('promontial_application_form')"
                          :is-filter="false"
            >
            </HeaderMobile>
        </template>
        <b-col cols="12" class="min-vh-100">
            <b-card>
                <ValidationObserver ref="identityForm" v-slot="{ invalid }">
                    <b-row class="align-items-center pb-5 border-bottom">
                        <b-col cols="12" md="8" >
                            <ValidationProvider name="national_id" rules="required|digits:11" v-slot="{valid, errors}">
                                <b-form-group :label="$t('national_id')" class="mb-md-0">
                                    <b-form-input
                                        v-mask="'###########'"
                                        v-model="national_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="d-flex justify-content-center align-items-center mt-0 mt-md-5" v-if="checkPermission('promotionalprocess_schooldata')">
                            <ProcessingButton :label="$t('fetch_data')" :processing="getIdentityInformationLoading" :disabled="invalid" @click="getInformation"/>
                        </b-col>
                    </b-row>
                </ValidationObserver>
                <ValidationObserver ref="requestForm" v-slot="{ invalid }">
                    <b-row class="mt-5">
                        <b-col cols="12" md="6" lg="4">
                            <ValidationProvider
                                name="campus_id"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <b-form-group :label="$t('campus')">
                                    <campus-selectbox
                                        v-model="form.campus_id"
                                        :validate-error="errors[0]"
                                    ></campus-selectbox>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" lg="4">
                            <ValidationProvider name="name"
                                                rules="required"
                                                v-slot="{valid, errors}">
                                <b-form-group :label="$t('name')">
                                    <b-form-input
                                        v-model="form.name"
                                        :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]"
                                                             v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>

                        <b-col cols="12" md="6" lg="4">
                            <ValidationProvider name="surname"
                                                rules="required"
                                                v-slot="{valid, errors}">
                                <b-form-group :label="$t('surname')">
                                    <b-form-input
                                        v-model="form.surname"
                                        :state="errors[0] ? false : (valid ? true : null)"></b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]"
                                                             v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" lg="4">
                            <ValidationProvider name="birthdate"
                                                rules="required"
                                                v-slot="{valid, errors}">
                                <b-form-group :label="$t('birthdate')">
                                    <select-date v-model="form.birthdate"
                                                 :validation-error="errors[0]"/>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" lg="4">
                            <ValidationProvider name="email" rules="required|email" v-slot="{valid, errors}">
                                <b-form-group :label="$t('email')">
                                    <b-form-input type="text"
                                                  v-model="form.email"
                                                  :state="errors[0] ? false : (valid ? true : null)">
                                    </b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>

                        <b-col cols="12" md="6" lg="4">
                            <ValidationProvider name="mobile_tel" rules="required"
                                                v-slot="{valid, errors}">
                                <b-form-group :label="$t('gsm_no')">
                                    <b-form-input
                                        v-mask="'(5##)-###-####'"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        v-model="form.mobile_tel"></b-form-input>
                                    <b-form-invalid-feedback v-if="errors[0]"
                                                             v-html="errors[0]"></b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" lg="4">
                            <ValidationProvider name="city_id" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('city_name')">
                                    <city-selectbox
                                        :validateError="errors[0]"
                                        v-model="form.city_id">
                                    </city-selectbox>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" lg="4">
                            <ValidationProvider name="district_id" rules="required"
                                                v-slot="{valid, errors}">
                                <b-form-group :label="$t('district')">
                                    <district-outline-selectbox
                                        :city_id="form.city_id"
                                        :validateError="errors[0]"
                                        v-model="form.district_id">
                                    </district-outline-selectbox>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>

                        <b-col cols="12" md="6" lg="4">
                            <ValidationProvider name="school" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('school')">
                                    <school-selectbox
                                        valueType="code"
                                        :validateError="errors[0]"
                                        v-model="form.school">
                                    </school-selectbox>
<!--                                    <b-form-input type="text"-->
<!--                                                  v-model="form.school"-->
<!--                                                  :state="errors[0] ? false : (valid ? true : null)">-->
<!--                                    </b-form-input>-->
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                </ValidationObserver>
                    <b-col class="d-flex justify-content-center align-items-center mt-5" v-if="step!==2 && checkPermission('promotionalprocess_store')">
                        <ProcessingButton :label="$t('save_and_go')" @click="save" :processing="loading" :disabled="loading"/>
                    </b-col>
                   <Step2 v-if="step===2" :promotionalProcessId="promotional_process_id"/>
            </b-card>
        </b-col>
    </app-layout>
</template>

<script>
import Step2 from "@/modules/promontialApplicationForm/pages/components/Step2.vue";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import PromontionApplicationServices from "@/services/PromontionApplicationServices";
import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox.vue";
import CitySelectbox from "@/components/interactive-fields/CitySelectbox.vue";
import CampusSelectbox from "@/components/interactive-fields/CampusSelectbox.vue";
import SchoolSelectbox from "@/components/interactive-fields/SchoolSelectbox.vue";
export default {
    components: {SchoolSelectbox, CampusSelectbox, CitySelectbox, DistrictOutlineSelectbox, ProcessingButton, Step2},
    data(){
        return {
            formProcess:null,
            value:1,
            step: 0,
            max: 2,
            promotional_process_id:null,
            form:{
                name:null,
                surname:null,
                birthdate:null,
                email:null,
                mobile_tel:null,
                promotional_process_id:null,
                city_id:null,
                district_id:null,
                campus_id:null,
                school:null,
                national_id:null
            },
            loading:false,
            getIdentityInformationLoading:false,
            national_id:null
        }
    },
    metaInfo() {
        return {
            title: this.$t("promontial_application_form"),
        };
    },
    methods:{
        async getInformation(){
            const isValid=await this.$refs.identityForm.validate()
            if(!isValid) return
            this.getIdentityInformationLoading = true
            try {
                const res = await PromontionApplicationServices.getInformationData(this.national_id)
                const data =res.data.data
                this.form={
                    school:data.school,
                    city:data.city,
                    city_id:data.city_id,
                    district_id:data.district_id,
                    district:data.district
                }
                this.$toast.success(this.$t("success"));
            }catch (err){
                this.showErrors(err,this.$refs.identityForm)
            }finally{
                this.getIdentityInformationLoading = false
            }
        },
        async save(){
            const isValid=await this.$refs.requestForm.validate()
            const isIdentityValid=await this.$refs.identityForm.validate()
            if(!isValid && !isIdentityValid) return
            this.loading=true
            this.form.national_id=this.national_id
            try {
                const res = await PromontionApplicationServices.saveInformationData(this.form)
                this.$toast.success(this.$t("api." + res.data.message));
                this.promotional_process_id=res.data.data.id
                this.step=2
            }catch (err){
                const isIdentityInvalid=!!err.data.errors.national_id
                this.showErrors(err,this.$refs.requestForm,false,isIdentityInvalid)
                this.showErrors(err,this.$refs.identityForm)
            }finally {
                this.loading=false;
            }
        },
    }
}
</script>


<style scoped>

</style>
